import React from "react";
import moment from "moment";
import jsPDF from "jspdf";
import "rasterizehtml";
import * as html2canvas from "html2canvas";

import { H3, H6, P } from "../../atoms/Texts";
import { LinkButton } from "../../atoms/Buttons";

import Joyride from "react-joyride";
import { useWalkthrough } from "../../../shared/hooks/useWalkthrough";

window.html2canvas = html2canvas;

const saveCaseAsPDF = (name) => {
  const unit = "pt";
  const size = "A4"; // Use A1, A2, A3 or A4
  const orientation = "portrait";

  html2canvas(document.querySelector("#case-details")).then((canvas) => {
    const imgData = canvas.toDataURL("image/jpeg");
    let pdf = new jsPDF(orientation, unit, size);
    pdf.addImage(imgData, "JPEG", 0, 0, 595, 842);
    pdf.save(name);
  });
};

export const CaseOverviewPage = ({ details }) => {
  const steps = [
    {
      target: ".overview-case",
      content: "Here are all personal information of a user in this case.",
    },
    {
      target: ".save-pdf",
      content: "Save the information as a pdf file",
    },

    {
      target: ".living-situation",
      content: "Gives more information about the living situation of the user",
    },
    {
      target: ".housing",
      content: "Gives more information about the housing situation of the user",
    },
    {
      target: ".legal",
      content: "Gives more information about the legal situation of the user",
    },
  ];

  const { joyrideProps } = useWalkthrough({
    steps,
    walkthroughKey: "case_detail_overview",
    pageSpecific: true, // Each page tracks separately
  });

  return (
    <>
      <Joyride
        key={joyrideProps.run ? "walkthrough-active" : "walkthrough-inactive"}
        {...joyrideProps}
      />

      <div className="overview-case">
        <div className="flex items-center justify-between">
          <H6 color="#22202C">Personal Background Information</H6>
          <div className="flex items-center">
            <LinkButton
              className="save-pdf"
              color="#22202D"
              fontFamily="regular"
              onClick={() => saveCaseAsPDF(details?.name)}
            >
              Save as PDF
            </LinkButton>
          </div>
        </div>

        <section className="mt-6 bg-white overview-case">
          <div className="bg-gray-200 px-5 py-2">
            <H3 color="#22202C" fontSize="14px">
              Personal Information
            </H3>
          </div>

          <article className="py-3 px-5 grid md:grid-cols-2 gap-6">
            <div>
              <H6
                color="#7D7B96"
                fontFamily="medium"
                fontSize="16px"
                className="mb-2"
              >
                Gender
              </H6>

              <P color="#22202C" fontFamily="semi" className=" capitalize">
                Female
              </P>
            </div>
            <div>
              <H6
                color="#7D7B96"
                fontFamily="medium"
                fontSize="16px"
                className="mb-2"
              >
                Age
              </H6>

              <P color="#22202C" fontFamily="semi" className=" capitalize">
                20 years
              </P>
            </div>
          </article>
        </section>

        <section className="my-8 bg-white living-situation ">
          <div className="bg-gray-200 px-5 py-2">
            <H3 color="#22202C" fontSize="14px">
              Living Situation
            </H3>
          </div>

          <article className="py-3 px-5 grid md:grid-cols-2 gap-6 ">
            <div>
              <H6
                color="#7D7B96"
                fontFamily="medium"
                fontSize="16px"
                className="mb-2"
              >
                Household
              </H6>

              <P color="#22202C" fontFamily="semi" className=" capitalize">
                2
              </P>
            </div>
            <div>
              <H6
                color="#7D7B96"
                fontFamily="medium"
                fontSize="16px"
                className="mb-2"
              >
                Housing
              </H6>

              <P color="#22202C" fontFamily="semi" className=" capitalize">
                Homeless
              </P>
            </div>
          </article>
        </section>

        <section className=" bg-white housing ">
          <div className="bg-gray-200 px-5 py-2">
            <H3 color="#22202C" fontSize="14px">
              Financial Status
            </H3>
          </div>

          <article className="py-3 px-5 grid md:grid-cols-2 gap-6">
            <div>
              <H6
                color="#7D7B96"
                fontFamily="medium"
                fontSize="16px"
                className="mb-2"
              >
                Employment
              </H6>

              <P color="#22202C" fontFamily="semi" className=" capitalize">
                Unemployed
              </P>
            </div>
            <div>
              <H6
                color="#7D7B96"
                fontFamily="medium"
                fontSize="16px"
                className="mb-2"
              >
                Income
              </H6>

              <P color="#22202C" fontFamily="semi" className=" capitalize">
                Low income
              </P>
            </div>
          </article>
        </section>

        <section className=" bg-white mt-8 legal">
          <div className="bg-gray-200 px-5 py-2">
            <H3 color="#22202C" fontSize="14px">
              Legal History
            </H3>
          </div>

          <article className="py-3 px-5 grid md:grid-cols-2 gap-6">
            <div>
              <H6
                color="#7D7B96"
                fontFamily="medium"
                fontSize="16px"
                className="mb-2"
              >
                Insurance
              </H6>

              <P color="#22202C" fontFamily="semi" className=" capitalize">
                Not Insured
              </P>
            </div>
            <div>
              <H6
                color="#7D7B96"
                fontFamily="medium"
                fontSize="16px"
                className="mb-2"
              >
                Justice Involvement
              </H6>

              <P color="#22202C" fontFamily="semi" className=" capitalize">
                Criminal Justice History
              </P>
            </div>
          </article>
        </section>
      </div>
    </>
  );
};
